import { render, staticRenderFns } from "./OtherVendorsModalVendorRow.vue?vue&type=template&id=72bf8394&"
import script from "./OtherVendorsModalVendorRow.vue?vue&type=script&lang=js&"
export * from "./OtherVendorsModalVendorRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports